let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9I1It")).then(() => parcelRequire('i04af'));